import {inject} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ActivatedRouteSnapshot, CanDeactivateFn, RouterStateSnapshot} from '@angular/router';
import {IczModalService, SimpleDialogComponent} from '@icz/angular-modal';
import {SKIPPED_URLS_FOR_UNSAVED_GUARD} from '../application-core.providers';
import {IFormGroupCheckable, openModalOnChanges} from '../services/check-unsaved/form-group-checks';

const guardUnsaved = (component: IFormGroupCheckable, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot) => {
  const skippedUrls = inject(SKIPPED_URLS_FOR_UNSAVED_GUARD);

  if (skippedUrls.includes(nextState.url)) {
    return true;
  }
  else {
    const modalService = inject(IczModalService);

    const isDialogAlreadyOpen = modalService.hasOpenModalOfType(SimpleDialogComponent);

    if (isDialogAlreadyOpen) {
      return false;
    } else {
      return openModalOnChanges<Observable<boolean>|boolean>(
        component,
        modalService,
        {
          changesDetected: afterClosed$ => {
            return afterClosed$.pipe(
              map(result => {
                return !result;
              })
            );
          },
          changesNotDetected: () => true
        }
      );
    }
  }
};

export function guardUnsavedForm(): CanDeactivateFn<IFormGroupCheckable> {
  return guardUnsaved;
};
